import { axiosInstance } from "@/lib/axios";
import type {
    SiteSettings,
    UpdateSocialPayload,
    AddLocationPayload,
    UpdateLocationPayload,
    UpdateDeliveryPayload,
    StoreLocation,
    DeliverySettings,
    SocialMedia,
} from "@/types/settings.types";

const BASE_URL = '/settings';

// ===============================
// GET SETTINGS
// ===============================
export const getSettings = async (): Promise<SiteSettings> => {
    const { data } = await axiosInstance.get(BASE_URL);
    return data.data;
};

// ===============================
// UPDATE GENERAL
// ===============================
export const updateGeneral = async (
    payload: FormData
): Promise<SiteSettings> => {
    const { data } = await axiosInstance.put(`${BASE_URL}/general`, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data.data;
};

// ===============================
// UPDATE SOCIAL
// ===============================
export const updateSocial = async (
    payload: UpdateSocialPayload
): Promise<SocialMedia> => {
    const { data } = await axiosInstance.put(`${BASE_URL}/social`, payload);
    return data.data;
};

// ===============================
// ADD LOCATION
// ===============================
export const addLocation = async (
    payload: AddLocationPayload
): Promise<StoreLocation> => {
    const { data } = await axiosInstance.post(`${BASE_URL}/location`, payload);
    return data.data;
};

// ===============================
// UPDATE LOCATION
// ===============================
export const updateLocation = async (
    id: string,
    payload: UpdateLocationPayload
): Promise<StoreLocation> => {
    const { data } = await axiosInstance.put(
        `${BASE_URL}/location/${id}`,
        payload
    );
    return data.data;
};

// ===============================
// DELETE LOCATION
// ===============================
export const deleteLocation = async (id: string): Promise<void> => {
    await axiosInstance.delete(`${BASE_URL}/location/${id}`);
};

// ===============================
// UPDATE DELIVERY
// ===============================
export const updateDelivery = async (
    payload: UpdateDeliveryPayload
): Promise<DeliverySettings> => {
    const { data } = await axiosInstance.put(
        `${BASE_URL}/delivery`,
        payload
    );
    return data.data;
};

// ===============================
// RESET AI USAGE
// ===============================
export const resetAiUsage = async (): Promise<void> => {
    await axiosInstance.post(`${BASE_URL}/ai-usage/reset`);
};

// ===============================
// UPDATE SLICKPAY
// ===============================
export const updateSlickpay = async (payload: {
    slickpayEnabled: boolean;
    publicKey?: string;
    accountUuid?: string;
    isProduction: boolean;
    fees: number;
}): Promise<any> => {
    const { data } = await axiosInstance.put(`${BASE_URL}/slickpay`, payload);
    return data.data;
};